import { ENV_TEACHR, ENV_VERIFIED_TRAINER } from "./environment.config";

const appBrand = process.env.REACT_APP_BRAND ?? ENV_TEACHR;
const debugMode = process.env.REACT_APP_BUILD_ENV === "prod" ? false : true;
const uriSite = appBrand === ENV_VERIFIED_TRAINER ? "https://verified-trainer.com/" :  "https://teachr.fr"

const firebaseConfigVt = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseConfigTeachr = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

var config = {
  // API config process.env.REACT_APP_BRAND
  appVersion: process.env.REACT_APP_VERSION,
  firebase:
    process.env.REACT_APP_BRAND === ENV_VERIFIED_TRAINER
      ? firebaseConfigVt
      : firebaseConfigTeachr,
  phoneNumber: process.env.REACT_APP_PHONE_NUMBER,
  debugMode: debugMode,
  url_AE: process.env.REACT_APP_URL_AE,
  // URL de la page partenaire vers laquelle on redirige les profs ayant peu d'élèves
  // et souhaitant des conseils. Facilement modifiable via la variable d'env dédiée.
  partnerAdviceUrl: `https://wannabefirst.com/teachr`,
  partnerAdviceUrlDeclarons: `https://wannabefirst.com/declarons`,

  adminId: process.env.REACT_APP_ADMIN_ID
    ? parseInt(process.env.REACT_APP_ADMIN_ID)
    : 5890,
  apiVersion: process.env.REACT_APP_API_VERSION,
  uriPath: process.env.REACT_APP_API_URI_PROD,
  uriSite: process.env.REACT_APP_SITE_URI_PROD ?? uriSite,
  uriApp: process.env.REACT_APP_SITE_URI_PROD ?? uriSite,
  firestoreMessagesCollection: "messages",
  addressKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,

  // premiumDisplay: process.env.REACT_APP_PREMIUM_DISPLAY,
  // stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY_PROD,
  // webHookSlackPromoCode:
  // process.env.REACT_APP_SLACK_WEBHOOK_PROMO_CODE ??
  // "https://hooks.slack.com/services/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",
  // webHookFlaggedMessages: process.env.REACT_APP_SLACK_WEBHOOK_FLAGGED_MESSAGES,
};


if (config.debugMode) {
  let newConfig = config;
  newConfig.adminId = process.env.REACT_APP_ADMIN_ID ? parseInt(process.env.REACT_APP_ADMIN_ID) : 46268;
  newConfig.apiVersion = "1_23_0";
  newConfig.uriPath = process.env.REACT_APP_API_URI_STAGING;
  newConfig.uriSite = "https://staging-site.teachr.fr";
  // newConfig.uriSite = process.env.REACT_APP_SITE_URI_STAGING ?? "https://staging-site.teachr.fr";
  newConfig.firestoreMessagesCollection = "messages_dev";
  newConfig.addressKey = process.env.REACT_ADDRESS_KEY;
  // newConfig.stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY_TEST;
  config = newConfig;
}

export default config;
